import React from "react";
import { Link } from "react-router-dom";

const ErrorDynamic = ({ errormsg }) => {
    const styles = {
        body: {
            backgroundColor: "#95c2de",
            height: "100vh",
            margin: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        mainbox: {
            backgroundColor: "#95c2de",
            height: "600px",
            width: "600px",
            position: "relative",
        },
        err: {
            color: "#ffffff",
            fontFamily: "'Nunito Sans', sans-serif",
            fontSize: "11rem",
            position: "absolute",
            left: "0%",
            top: "8%",
        },
        err11: {
            color: "#ffffff",
            fontFamily: "'Nunito Sans', sans-serif",
            fontSize: "11rem",
            position: "absolute",
            left: "20%",
            top: "8%",
        },
        err12: {
            color: "#ffffff",
            fontFamily: "'Nunito Sans', sans-serif",
            fontSize: "11rem",
            position: "absolute",
            left: "40%",
            top: "8%",
        },
        far: {
            position: "absolute",
            fontSize: "8.5rem",
            left: "60%",
            top: "18%",
            color: "#ffffff",
        },
        err2: {
            color: "#ffffff",
            fontFamily: "'Nunito Sans', sans-serif",
            fontSize: "11rem",
            position: "absolute",
            left: "85%",
            top: "8%",
        },
        msg: {
            textAlign: "center",
            fontFamily: "'Nunito Sans', sans-serif",
            fontSize: "1.6rem",
            position: "absolute",
            left: "16%",
            top: "45%",
            width: "75%",
            color: "white",
        },
        link: {
            textDecoration: "none",
            color: "white",
        },
        linkHover: {
            textDecoration: "underline",
        },
    };

    return (
        <div style={styles.body}>
            <div style={styles.mainbox}>
                <div style={styles.err}>E</div>
                <div style={styles.err11}>R</div>
                <div style={styles.err12}>R</div>
                <i className="far fa-question-circle fa-spin" style={styles.far}></i>
                <div style={styles.err2}>R</div>
                <div style={styles.msg}>
                    {
                        errormsg ?
                            errormsg :
                            <>
                                Maybe this page moved? Got deleted? Is hiding out in quarantine? Never
                                existed in the first place?
                            </>
                    }
                    <p>
                        Let's go{" "}
                        <Link
                            to={-1}
                            style={styles.link}
                            onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
                            onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                        >
                            <b>BACK</b>
                        </Link>{" "}
                        and try from there.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ErrorDynamic;
